import { render, staticRenderFns } from "./NotificationsRender.vue?vue&type=template&id=24ca4a33"
import script from "./NotificationsRender.vue?vue&type=script&lang=js"
export * from "./NotificationsRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports